import { Space } from "antd";
import { ReactNode } from "react";

interface ButtonTransferModeProps {
  text: string;
  icon?: ReactNode;
  width?: string | number;
  height?: number;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  size?: "xsmall" | "small" | "medium" | "large" | "xlarge";
  type?: "button" | "submit" | "reset";
  suffixIcon?: ReactNode;
  active?: boolean;
}

export const ButtonTransferMode: React.FC<ButtonTransferModeProps> = ({
  text,
  icon,
  width,
  height,
  onClick,
  className = "",
  disabled = false,
  size = "medium",
  type = "button",
  suffixIcon,
  active,
}) => {
  return (
    <button
      className={`transfer-mode-button ${active ? "transfer-mode-button-active" : ""
        } ${className}`}
      style={{
        width:
          width ||
          (size === "xsmall"
            ? 100
            : size === "small"
              ? 136
              : size === "large"
                ? 200
                : size === "xlarge"
                  ? 240
                  : 180),
        height:
          height ||
          (size === "xsmall"
            ? 24
            : size === "small"
              ? 32
              : size === "large"
                ? 48
                : size === "xlarge"
                  ? 56
                  : 40),
        minWidth: "max-content",
      }}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      <Space align="center" size={8}>
        {icon && <span className="button-icon">{icon}</span>}
        <span
          className={`button-text ${disabled ? "disabled-text" : ""}`}
          style={{
            fontSize:
              size === "xsmall"
                ? 10
                : size === "small"
                  ? 12
                  : size === "large"
                    ? 16
                    : size === "xlarge"
                      ? 18
                      : 14,
          }}
        >
          {text}
        </span>
        {suffixIcon && <span className="button-icon">{suffixIcon}</span>}
      </Space>
    </button>
  );
};
